import React from "react";
import { Svg, SVG_ICONS } from "../__common/Svg/Svg";
import { Typography } from "../__common/Typography/Typography";
import { Container } from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { LayoutState } from "../../store/reducers/layout-reducer";
import {
  MaintenanceState,
  DEFAULT_MAINTENANCE_STATE,
} from "../../types/maintenance-page";
import { getCachedMaintenanceState } from "../../hooks/maintenance-page-hooks";
import "./MaintenancePage.scss";
import { UtilsDateTime } from "../../utils/UtilsDateTIme";

interface Props {
  maintenanceState?: MaintenanceState;
}

export const MaintenancePage = ({ maintenanceState }: Props) => {
  const { t } = useTranslation();
  const { isDarkMode } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );

  const state =
    maintenanceState ||
    getCachedMaintenanceState() ||
    DEFAULT_MAINTENANCE_STATE;

  return (
    <div className="maintenancePage__container">
      <Container>
        <div className="maintenancePage">
          <div className="maintenancePage__content">
            <Svg
              icon={
                isDarkMode
                  ? SVG_ICONS.ERROR_MAINTENANCE_DARK
                  : SVG_ICONS.ERROR_MAINTENANCE
              }
              className="maintenancePage__content__icon"
            />
            <div className="maintenancePage__content__description">
              <Typography
                className="maintenancePage__content__description__title"
                variant="title3"
              >
                {t("PRIVACY_MAINTENANCE")}
              </Typography>
              <Typography
                className="maintenancePage__content__description__caption"
                variant="body2"
              >
                {t("PRIVACY_MAINTENANCE_BODY")}
              </Typography>
            </div>
            {state.dateTime && (
              <div className="maintenancePage__content__schedule">
                <Typography
                  variant={"body2"}
                  className="maintenancePage__content__schedule__timestamp"
                >
                  {UtilsDateTime.formatMaintenanceDateTime(state.dateTime)}
                </Typography>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};
